<div class="carousel-wrapper" *ngIf="images && images.length">

  <!-- Main carousel -->
  <div class="carousel">
    <button
      class="nav-btn prev gallery-ctrl"
      type="button"
      (click)="prev()"
      *ngIf="images.length > 1"
    >
      &#10094;
    </button>

    <div class="viewport">
      <div
        class="track"
        [style.transform]="'translateX(-' + currentIndex * 100 + '%)'"
      >
        <div
          class="slide"
          *ngFor="let img of images; let i = index"
        >
          <!-- Click opens vertical gallery (starting from this image) -->
          <img
            [src]="img"
            [alt]="'Image ' + (i + 1)"
            loading="lazy"
            (click)="openGallery(i)"
          />
        </div>
      </div>
    </div>

    <button
      class="nav-btn next gallery-ctrl"
      type="button"
      (click)="next()"
      *ngIf="images.length > 1"
    >
      &#10095;
    </button>
  </div>

  <!-- Small thumbnails (optional, click to jump) -->
  <div class="thumb-row" *ngIf="images.length > 1">
    <div
      class="thumb"
      *ngFor="let img of images; let i = index"
      [class.active]="i === currentIndex"
      (click)="currentIndex = i"
    >
      <img [src]="img" [alt]="'Thumb ' + (i + 1)" />
    </div>
  </div>
</div>

<!-- ========================= -->
<!-- 1) Gallery carousel view  -->
<!-- ========================= -->
<div
  class="gallery-backdrop"
  *ngIf="showGallery"
  (click)="closeGallery()"
>
  <div
    class="gallery-content"
    (click)="$event.stopPropagation()"
  >
    <button class="close-btn gallery-ctrl" type="button" (click)="closeGallery()">
      &times;
    </button>

    <!-- Gallery Carousel -->
    <div class="gallery-carousel">
      <button
        class="gallery-nav-btn prev gallery-ctrl"
        type="button"
        (click)="prevGallery()"
        [disabled]="images.length <= 1"
        *ngIf="images.length > 1"
      >
        &#10094;
      </button>

      <div class="gallery-viewport">
        <div
          class="gallery-track"
          [style.transform]="'translateX(-' + galleryIndex * 100 + '%)'"
        >
          <div
            class="gallery-slide"
            *ngFor="let img of images; let i = index"
          >
            <img
              [src]="img"
              [alt]="'Image ' + (i + 1)"
            />
          </div>
        </div>
      </div>

      <button
        class="gallery-nav-btn next gallery-ctrl"
        type="button"
        (click)="nextGallery()"
        [disabled]="images.length <= 1"
        *ngIf="images.length > 1"
      >
        &#10095;
      </button>
    </div>

    <!-- Image counter -->
    <div class="gallery-counter" *ngIf="images.length > 1">
      {{ galleryIndex + 1 }} / {{ images.length }}
    </div>
  </div>
</div>

<!-- ========================= -->
<!-- 2) Full page zoom view   -->
<!-- ========================= -->
<div
  class="zoom-backdrop"
  *ngIf="zoomIndex !== null"
  (click)="closeZoom()"
>
  <div
    class="zoom-content"
    (click)="$event.stopPropagation()"
  >
    <button class="close-btn gallery-ctrl" type="button" (click)="closeZoom()">
      &times;
    </button>

    <div class="zoom-toolbar">
      <button type="button" class="gallery-ctrl" (click)="prevZoom($event)">&#10094;</button>

      <button type="button" class="gallery-ctrl" (click)="zoomOut($event)">-</button>
      <span>{{ (zoomLevel * 100) | number:'1.0-0' }}%</span>
      <button type="button" class="gallery-ctrl" (click)="zoomIn($event)">+</button>
      <button type="button" class="gallery-ctrl" (click)="resetZoom($event)">Reset</button>

      <button type="button" class="gallery-ctrl" (click)="nextZoom($event)">&#10095;</button>
    </div>

    <div class="zoom-scroll">
      <img
        class="zoom-image"
        [src]="images[zoomIndex!]"
        [alt]="'Image ' + (zoomIndex! + 1)"
        [style.transform]="'scale(' + zoomLevel + ')'"
      />
    </div>
  </div>
</div>
